import React from 'react'
import styled from 'styled-components';

const StyledDotsLoadingSpinner = styled.div`
display: flex;
justify-content: center;

.content {
  padding: 15px;
  overflow: hidden; 

  
}

.load-wrapp {
  float: left;
  width: auto;
  height: auto;
  margin: 0 10px 10px 0;
  padding: 20px 20px 20px;
  border-radius: 5px;
  text-align: center;
  /* background-color: #d8d8d8; */
}


.load-wrapp:last-child {
  margin-right: 0;
}

.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  padding: 1px;
  margin: 5px;
  border-radius: 15px;
  background-color: #999;
}

.load-3 .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load-3 .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load-3 .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}

@keyframes loadingC {
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
`;
const DotsLoadingSpinner = () => {
    return (
        <StyledDotsLoadingSpinner>
            <div class="content">
                <div class="load-wrapp">
                    <div class="load-3">
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                    </div>
                </div>
            </div>
        </StyledDotsLoadingSpinner>
    )
}

export default DotsLoadingSpinner